const request = require('superagent');

const apiWallets = {
    kwallet: {
        getDetails: (token) => request.get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/wallet/account`)
            .set('Authorization', `Bearer ${token}`)
            .send(),
        getTransations: ({ token, params }) => request.get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/wallet/transactions`)
            .query(params)
            .set('Authorization', `Bearer ${token}`)
            .send(),
        makeADeposit: ({ token, params }) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/wallet/deposit`)
            .set('Authorization', `Bearer ${token}`)
            .send(params),
        getIsActive: async (token) => {
            try {
                const response = await request.get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/wallet/account`).set('Authorization', `Bearer ${token}`)
                    .send();
                return true;
            } catch (error) {
                return false;
            }
        },
        sendFunds: ({ token, amount, idTransfer }) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/wallet/transfer`)
            .set('Authorization', `Bearer ${token}`)
            .set('Content-Type', 'application/json')
            .send({
                amount,
                notes: '',
                target_account_number: idTransfer,
            }),
        activateWallet: (token) => request.post(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/wallet/create_account`)
            .set('Authorization', `Bearer ${token}`)
            .send(),
    },
};

const WalletsAPI = {
    getWalletTransactions: ({
        wallet, token, params,
    }) => apiWallets[wallet].getTransations({ token, params }),
    getWalletDetails: ({
        wallet, token,
    }) => apiWallets[wallet].getDetails(token),
    makeADeposit: ({
        wallet, token, params,
    }) => apiWallets[wallet].makeADeposit({ token, params }),
    getWalletIsActive: ({
        wallet, token,
    }) => apiWallets[wallet].getIsActive(token),
    activateWallet: ({
        wallet, token,
    }) => apiWallets[wallet].activateWallet(token),
    sendFunds: ({
        wallet, token, amount, idTransfer,
    }) => apiWallets[wallet].sendFunds({ token, amount, idTransfer }),
};

export default WalletsAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/wallets.js
 **/